import Vue from 'vue'
import VueRouter from 'vue-router'
import Confirmation from '../views/Confirmation.vue'
import Home from '../views/Home.vue'
import { Route } from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: (route: Route) => ({
      step: route.query.step,
      token: route.query.token
    })
  },
  {
    path: '/vielen-dank',
    name: 'Confirmation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Confirmation
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
